import { render, staticRenderFns } from "./Solicitantes.vue?vue&type=template&id=710ddcfe&"
import script from "./Solicitantes.vue?vue&type=script&lang=js&"
export * from "./Solicitantes.vue?vue&type=script&lang=js&"
import style0 from "./Solicitantes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports